import DatePicker from 'react-datepicker';
import { FloatingLabel, Form } from 'react-bootstrap';
import { forwardRef } from 'react';
import './index.css';
import { IoClose } from 'react-icons/io5';

const CustomInput = forwardRef((props, ref) => {
  const { value, onClick, placeholder, className, onClear } = props;
  return (
    <>
      <FloatingLabel controlId={placeholder} label={placeholder} className={className}>
        <Form.Control
          size="sm"
          onChange={() => {}}
          onClick={onClick}
          ref={ref}
          value={value}
          placeholder={placeholder}
          autoComplete="off"
        />
      </FloatingLabel>
      {value && (
        <span
          onClick={onClear}
          className="position-absolute cursor-pointer"
          style={{
            top: '50%',
            right: '10px',
            transform: 'translateY(-50%)',
          }}
        >
          <IoClose />
        </span>
      )}
    </>
  );
});

export default function DatePickerComponent({ placeholderText, onDateChange, selectedDate, className = '' }) {
  const handleDateChange = (date) => {
    const formattedDate = date ? date.toISOString().split('T')[0] : null;
    onDateChange(formattedDate);
  };

  return (
    <DatePicker
      dateFormat="dd/MM/yyyy"
      selected={selectedDate}
      placeholderText={placeholderText}
      onChange={handleDateChange}
      customInput={<CustomInput className={className} onClear={() => onDateChange('')} />}
    />
  );
}
